/*
  THAANI Noka-Buybox (snippets/thaani-noka-buybox.liquid).

  Schreibt Pack x Anzahl in Dawns Mengenfeld und den gewaehlten Plan ins
  Feld selling_plan, beides per form="" am Produktformular. Danach werden
  alle sichtbaren Preise aus denselben Zahlen gerechnet: Pack-Kacheln,
  Abo/Einmalkauf, grosser Preis, Portionszeile, Kaufbutton, Sticky-Leiste
  und Versandhinweis. So kann nirgends ein anderer Betrag stehen als der,
  der in den Warenkorb geht.

  Preis je Glas: Abo-Zuordnung (echter Plan) bzw. Vorschau-Rabatt, sonst
  Mengenpreis aus quantity_price_breaks, sonst Variantenpreis.
*/

if (!customElements.get('thaani-noka-buybox')) {
  customElements.define(
    'thaani-noka-buybox',
    class ThaaniNokaBuybox extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info') || this.closest('[data-noka-root]');
        this.base = Number(this.dataset.price) || 0;
        this.portions = Number(this.dataset.portions) || 0;
        this.mockPercent = Number(this.dataset.mockPercent) || 0;
        // Paket-Angebote als Vorschau ("3:15" = 3 Glaeser 15 % guenstiger,
        // "6:2" = 6 Glaeser plus 2 gratis). Nur Anzeige und Menge, der Preis
        // im Checkout kommt aus einem Shopify-Rabatt.
        const deals = (text) => Object.fromEntries(
          String(text || '').split(',').map((part) => part.split(':').map((n) => Number(n.trim()))).filter(([a, b]) => a > 0 && b > 0)
        );
        this.packRabatt = deals(this.dataset.packRabatt);
        this.packGratis = deals(this.dataset.packGratis);
        this.aboMode = this.dataset.aboMode || 'none';
        this.threshold = Number(this.dataset.threshold) || 0;
        this.cartTotal = Number(this.dataset.cartTotal) || 0;
        this.cartQuantity = Number(this.dataset.cartQuantity) || 0;
        this.breaks = this.readJson('[data-breaks]');
        this.plans = this.readJson('[data-plans]');
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'de-CH', {
          style: 'currency',
          currency: this.dataset.currency || 'CHF',
        });

        this.countInput = this.querySelector('[data-count]');
        this.planInput = this.querySelector('[data-selling-plan]');

        this.onChange = (event) => {
          if (event.target === this.countInput) this.clampCount();
          this.sync();
        };
        this.onClick = (event) => {
          const step = event.target.closest('[data-step]');
          if (!step || !this.countInput) return;
          this.countInput.value = Number(this.countInput.value || 1) + Number(step.dataset.step);
          this.clampCount();
          this.sync();
        };
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);

        // Abo-Vorteile weiter unten: Button springt hierher und waehlt das Abo.
        this.onAboLink = (event) => {
          const link = event.target.closest('[data-noka-abo-link]');
          if (!link) return;
          event.preventDefault();
          const abo = this.querySelector('[data-kauf][value="abo"]');
          if (abo) {
            abo.checked = true;
            this.sync();
          }
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          (abo || this.querySelector('[data-pack]:checked'))?.focus({ preventScroll: true });
        };
        document.addEventListener('click', this.onAboLink);

        // Dawn rendert Preis und Button nach dem Hinzufuegen neu, danach nachziehen.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribers = [
            subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(() => this.sync())),
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              const total = event?.cartData?.total_price;
              if (typeof total === 'number') this.cartTotal = total;
              requestAnimationFrame(() => this.sync());
            }),
          ];
        }

        // Sofort rechnen, rAF laeuft in Hintergrund-Tabs nicht. Der zweite Lauf
        // faengt Dawns eigenen Preis-Rerender nach dem Laden ab.
        this.sync();
        this.frame = requestAnimationFrame(() => this.sync());
        this.onLoad = () => this.sync();
        window.addEventListener('load', this.onLoad, { once: true });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        window.removeEventListener('load', this.onLoad);
        document.removeEventListener('click', this.onAboLink);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        this.unsubscribers?.forEach((unsubscribe) => unsubscribe?.());
      }

      readJson(selector) {
        try {
          return JSON.parse(this.querySelector(selector)?.textContent || '[]') || [];
        } catch (error) {
          return [];
        }
      }

      money(cents) {
        return this.formatter.format(Math.round(cents) / 100);
      }

      clampCount() {
        const input = this.countInput;
        const max = Number(input.max) || 99;
        const value = Math.round(Number(input.value) || 1);
        input.value = Math.min(Math.max(value, 1), max);
      }

      get pack() {
        return Number(this.querySelector('[data-pack]:checked')?.value) || 1;
      }

      gratis(size) {
        return this.packGratis[size] || 0;
      }

      // Preis je bezahltem Glas nach Paket-Rabatt
      deal(price, size) {
        const percent = this.packRabatt[size] || 0;
        return percent > 0 ? Math.round(price * (1 - percent / 100)) : price;
      }

      get count() {
        return Number(this.countInput?.value) || 1;
      }

      // Intervall als Pillen (Radios) oder als Select
      get planValue() {
        const radio = this.querySelector('[data-interval]:checked');
        if (radio) return radio.value;
        const select = this.querySelector('select[data-interval]');
        return select ? select.value : '';
      }

      get isAbo() {
        return this.querySelector('[data-kauf]:checked')?.value === 'abo';
      }

      // Preis je Glas ohne Abo, inkl. Mengenpreis fuer die Gesamtmenge im Warenkorb.
      unitOneTime(quantity) {
        const eligible = this.breaks
          .filter((item) => item.minimum_quantity <= this.cartQuantity + quantity)
          .sort((a, b) => b.minimum_quantity - a.minimum_quantity);
        return eligible.length ? eligible[0].price : this.base;
      }

      unitAbo() {
        if (this.aboMode === 'real') {
          const planId = this.planValue;
          const allocation = this.plans.find((item) => String(item.selling_plan.id) === String(planId));
          return allocation ? allocation.price : this.base;
        }
        if (this.aboMode === 'mock') return Math.round(this.base * (1 - this.mockPercent / 100));
        return this.base;
      }

      unit(quantity) {
        return this.isAbo ? this.unitAbo() : this.unitOneTime(quantity);
      }

      // Gesamt und effektiver Preis je Glas fuer eine Packgroesse
      offer(size, abo = this.isAbo) {
        const paid = size * this.count;
        const quantity = (size + this.gratis(size)) * this.count;
        const price = abo ? this.unitAbo() : this.unitOneTime(paid);
        const total = this.deal(price, size) * paid;
        return { paid, quantity, total, unit: total / quantity };
      }

      percent(price) {
        return this.base > 0 ? Math.round(((this.base - price) / this.base) * 100) : 0;
      }

      sync() {
        const { quantity, unit, total } = this.offer(this.pack);

        this.writeForm(quantity);
        this.syncPacks();
        this.syncKauf();

        const summary = this.querySelector('[data-summary]');
        if (summary) summary.textContent = this.count > 1 || quantity > this.pack ? `${quantity} × ${this.money(unit)}` : '';

        this.syncOutside(unit, total);
        this.classList.toggle('is-abo', this.isAbo);
      }

      writeForm(quantity) {
        const input = this.productInfo?.querySelector('.quantity__input');
        if (input && String(input.value) !== String(quantity)) {
          input.value = quantity;
        }
        if (this.planInput) this.planInput.value = this.isAbo ? this.planValue || '' : '';
      }

      syncPacks() {
        this.querySelectorAll('[data-pack]').forEach((input) => {
          const size = Number(input.value);
          const card = input.nextElementSibling;
          const { unit, total } = this.offer(size);
          card.querySelector('[data-pack-total]').textContent = this.money(total / this.count);
          const portion = card.querySelector('[data-pack-portion]');
          if (portion && this.portions > 0) {
            portion.textContent = `${this.money(unit / this.portions)} ${this.dataset.portionLabel || ''}`.trim();
          }
          // Badge: Ersparnis je Glas aus Paket-Rabatt, Gratis-Glaesern und
          // Mengenpreisen. Das Abo hat sein eigenes Badge.
          const free = this.gratis(size);
          const oneTimePercent = this.percent(this.offer(size, false).unit);
          const freeText = free > 0 ? (this.dataset.gratisLabel || '+ [anzahl] gratis').replace('[anzahl]', free) : '';
          const extra = card.querySelector('[data-pack-gratis]');
          if (extra) {
            extra.hidden = free <= 0;
            extra.textContent = freeText;
          }
          const saving = card.querySelector('[data-pack-saving]');
          const popular = card.querySelector('[data-pack-popular]');
          if (saving) {
            saving.hidden = oneTimePercent <= 0;
            saving.textContent = oneTimePercent > 0 ? `${this.dataset.savingLabel} ${oneTimePercent} %` : '';
          }
          if (popular) popular.hidden = oneTimePercent > 0;
        });
      }

      syncKauf() {
        if (this.aboMode === 'none') return;
        const aboOffer = this.offer(this.pack, true);
        const oneOffer = this.offer(this.pack, false);
        const percent = this.percent(this.unitAbo());

        const aboPrice = this.querySelector('[data-abo-price]');
        const aboCompare = this.querySelector('[data-abo-compare]');
        const einmalPrice = this.querySelector('[data-einmal-price]');
        const badge = this.querySelector('[data-abo-badge]');

        if (aboPrice) aboPrice.textContent = this.money(aboOffer.total);
        if (aboCompare) {
          aboCompare.hidden = aboOffer.total >= oneOffer.total;
          aboCompare.textContent = this.money(oneOffer.total);
        }
        if (einmalPrice) einmalPrice.textContent = this.money(oneOffer.total);
        if (badge) {
          badge.hidden = percent <= 0;
          badge.textContent = percent > 0 ? `${this.dataset.savingLabel} ${percent} %` : '';
        }
        const wrap = this.querySelector('[data-interval-wrap]');
        if (wrap) wrap.hidden = !this.isAbo;
      }

      syncOutside(unit, total) {
        const section = this.dataset.section;
        const root = this.productInfo || document;

        const price = document.getElementById(`price-${section}`);
        const regular = price?.querySelector('.price__regular .price-item--regular');
        if (regular) regular.textContent = this.money(unit);
        document.querySelectorAll(`[data-noka-unit="${section}"]`).forEach((node) => {
          node.textContent = this.money(unit);
        });
        document.querySelectorAll(`[data-noka-portion="${section}"]`).forEach((node) => {
          if (this.portions > 0) node.textContent = `${this.money(unit / this.portions)} ${this.dataset.portionLabel || ''}`.trim();
        });
        document.querySelectorAll(`[data-noka-total="${section}"]`).forEach((node) => {
          node.textContent = this.money(total);
        });

        const portion = root.querySelector('.thaani-portionen__preis');
        if (portion && this.portions > 0) {
          portion.textContent = `${this.money(unit / this.portions)} ${this.dataset.portionLabel || ''}`.trim();
        }

        const separator = this.dataset.ctaSeparator || ' – ';
        document.querySelectorAll(`[data-noka-cta-price="${section}"]`).forEach((node) => {
          node.textContent = `${separator}${this.money(total)}`;
        });

        document.querySelectorAll(`[data-noka-sticky-price="${section}"]`).forEach((node) => {
          node.textContent = this.money(total);
        });

        document.querySelectorAll(`[data-noka-versand="${section}"]`).forEach((node) => {
          if (!this.threshold) return;
          const missing = this.threshold - this.cartTotal - total;
          const reached = missing <= 0;
          node.classList.toggle('is-reached', reached);
          const text = node.querySelector('[data-versand-text]');
          if (text) {
            text.textContent = reached
              ? node.dataset.reached
              : node.dataset.missing.replace('[betrag]', this.money(missing));
          }
        });
      }
    }
  );
}
